import * as Actions from '../../actions/login';
import { createReducer } from 'redux-act';

export default createReducer({
	[Actions.loginPhaseChanged]: (state, payload) => ({ ...state, ...payload })
}, {});

